import {
  COMPETITIONS_CREATED,
  UPDATE_COMPETITION,
  SINGLE_COMPETITION,
  LIST_STARTLIST,
  LIST_VEHICLES,
  RACING_NUMBERS,
  ASSIGN_RACING_NUMBERS,
  ADD_VEHICLE,
  DELETE_VEHICLE,
  DELETE_COMPETITION_DRAFT,
  DELETE_MULTIPLE_VEHICLES,
  CANCEL_COMPETITION,
  COPY_COMPETITION,
  UPLOAD_VEHICLE_NUMBERS,
} from './config';

export async function getCreatedCompetitions() {
  const url = COMPETITIONS_CREATED;
  const token = localStorage.getItem('token');

  const competitions = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`This is an HTTP error: The status is ${res.status}`);
      }
    })
    .then((data) => {
      return data.competitions;
    })
    .catch((err) => {
      //console.error(err);
    });

  return competitions;
}

export async function updateCompetition(values, publish = false) {
  const url = UPDATE_COMPETITION;
  const token = localStorage.getItem('token');
  let data = values;

  if (publish) {
    data.isDraft = false;
  }

  let successFetch = false;

  await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Error updating competition');
    })
    .then((data) => {
      successFetch = true;
    })
    .catch((err) => {
      //console.error(err);
      successFetch = false;
    });

  if (successFetch) {
    const date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');

    const timeString = `${hours}:${minutes}`;

    if (publish) {
      return successFetch;
    } else {
      return timeString;
    }
  }

  return false;
}

export async function getCompetition(id) {
  const url = SINGLE_COMPETITION.replace('{competitionId}', id);
  const token = localStorage.getItem('token');

  const competition = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta tävlingen');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return competition;
}

export async function getStartlist(id) {
  const url = LIST_STARTLIST.replace('{competitionId}', id);
  const token = localStorage.getItem('token');

  const startlist = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta tävlingen');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });

  return startlist;
}

export async function getCompetitionVehicles(id) {
  const url = LIST_VEHICLES.replace('{competitionId}', id);
  const token = localStorage.getItem('token');

  const vehicles = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta fordon');
      }
    })
    .then((data) => {
      return data?.vehicles;
    })
    .catch((err) => {
      //console.error(err);
    });

  return vehicles;
}

export async function getRacingNumbers(id) {
  const url = RACING_NUMBERS.replace('{competitionId}', id);
  const token = localStorage.getItem('token');

  const racingNumbers = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta nummer');
      }
    })
    .then((data) => {
      return data?.raceNumbers;
    })
    .catch((err) => {
      //console.error(err);
    });

  return racingNumbers;
}

export async function assignRacingNumbers(competitionId, requestedNumber, email) {
  const url = ASSIGN_RACING_NUMBERS.replace('{competitionId}', competitionId);
  const token = localStorage.getItem('token');

  const requestBody = requestedNumber && email
    ? JSON.stringify({ requestedNumber, email })
    : null;

  let resultData = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: requestBody,
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Error assigning racenumbers');
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      // console.error(err);
    });

  return resultData;
}

export async function addVehicle(competitionId, racingNumbers) {
  const url = ADD_VEHICLE;
  const token = localStorage.getItem('token');

  const body = {
    competitionId: competitionId,
    racingNumbers: racingNumbers,
  };

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function deleteVehicle(competitionId, vehicleId) {
  const url = DELETE_VEHICLE.replace('{competitionId}', competitionId).replace(
    '{vehicleId}',
    vehicleId
  );
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte ta bort fordon');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function deleteCompetition(competitionId) {
  const url = DELETE_COMPETITION_DRAFT.replace(
    '{competitionId}',
    competitionId
  );
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte ta bort tävling');
      }
    })
    .then((data) => {
      return data.statusCode;
    })
    .catch((err) => {
      console.error(err);
    });

  return result;
}

export async function deleteMultipleVehicles(competitionId, vehicleIds) {
  const url = DELETE_MULTIPLE_VEHICLES.replace(
    '{competitionId}',
    competitionId
  );

  const token = localStorage.getItem('token');

  const body = {
    vehicleIds: vehicleIds,
  };

  const result = await fetch(url, {
    method: 'DELETE',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte ta bort fordon');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function cancelCompetition(competitionId) {
  const url = CANCEL_COMPETITION;
  const body = {
    competitionId: competitionId,
  };

  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });

  return result;
}

export async function copyCompetition(competitionId) {
  const url = COPY_COMPETITION?.replace('{competitionId}', competitionId);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return {
          statusCode: res.status,
        };
      }
    })
    .then((data) => {
      return data;
    });

  return result;
}

export async function uploadVehicleNumbers(formData) {
  const url = UPLOAD_VEHICLE_NUMBERS;
  const token = localStorage.getItem('token');

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: formData,
  }).then((response) => {
    if (!response.ok) throw new Error('Uppladdningen misslyckades');
    return response.json();
  });
}
